export default "__VITE_ASSET__kODzItME__"